(function () {

  'use strict';

  function pxWorkflowSource($rootScope, COLOR, ORIENTATION, PAPER_SIZE, RESOLUTION) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '=',
        filePathFormModel_ONEDRIVE: '=filePathFormModelOnedrive',
        filePathFormModel_SHAREPOINT: '=filePathFormModelSharepoint'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/source/workflowSource.template.html',
      link: function (scope, element, attrs) {

        scope.selectPlaceHolder = 'Select';

        scope.changeSource = function () {
          const shorthand = scope.workflowFormModel.source + '_VARIABLES';
          scope.fileNameShorthands.FILE_NAME_CONTEXT = scope.fileNameShorthands[shorthand];
          $rootScope.$broadcast('CHANGE_CONTEXT', { context: 'FILE_NAME_CONTEXT', list: scope.fileNameShorthands.FILE_NAME_CONTEXT });

          scope.fileNameFormModel.validateFileName();
          scope.filePathFormModel_SHAREPOINT.validateFilePath();
          scope.filePathFormModel_ONEDRIVE.validateFilePath();
        };

        scope.setItemOnModel = function (item, model, attr) {
          scope.workflowFormModel[model][attr] = item.id;
        };

        function setSelectOptions() {
          scope.SCAN_FILES_SETTINGS = {
            setting: {
              ORIENTATION: ORIENTATION.find(item => item.id === scope.workflowFormModel.SCAN_FILES.pageOrientation),
              COLOR: COLOR.find(item => item.id === scope.workflowFormModel.SCAN_FILES.color),
              PAPER_SIZE: PAPER_SIZE.find(item => item.id === scope.workflowFormModel.SCAN_FILES.paperSize),
              RESOLUTION: RESOLUTION.find(item => item.id === scope.workflowFormModel.SCAN_FILES.dotsPerInch)
            },
            selectable: {
              ORIENTATION: ORIENTATION,
              COLOR: COLOR,
              PAPER_SIZE: PAPER_SIZE,
              RESOLUTION: RESOLUTION
            }
          };
        }

        setSelectOptions();
      }
    };
  }

  pxWorkflowSource.$inject = ['$rootScope', 'COLOR', 'ORIENTATION', 'PAPER_SIZE', 'RESOLUTION'];

  angular
    .module('printix-admin')
    .directive('pxWorkflowSource', pxWorkflowSource);

})();
